"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LanguageSelector = void 0;
var _language_selectorModule = _interopRequireDefault(require("@albelli/arc-3/lib/language_selector.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var _react = _interopRequireWildcard(require("react"));
var _Separator = require("../Separator/Separator");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const LanguageSelector = _ref => {
  let {
    vendorFlagLinks,
    currentVendor,
    ...props
  } = _ref;
  // hack to make iOS devices recognize the flag as hover element
  const emptyCallback = (0, _react.useCallback)(() => {}, []);
  if (!vendorFlagLinks) return null;
  const currentFlagLink = vendorFlagLinks.find(l => l.vendorId === currentVendor) || vendorFlagLinks[0];
  if (!vendorFlagLinks.length || !currentFlagLink) return null;
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)("notranslate", _language_selectorModule.default["arc3-language_selector"])
  }, props), /*#__PURE__*/_react.default.createElement("i", {
    className: (0, _classnames.default)("arc3-multicolor-icon", currentFlagLink.flag),
    onClick: emptyCallback
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _language_selectorModule.default["language_selector__content"]
  }, vendorFlagLinks.map((i, j) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("a", {
    href: i.href
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: (0, _classnames.default)("arc3-multicolor-icon", i.flag)
  }), " ", i.text), /*#__PURE__*/_react.default.createElement(_Separator.Separator, null)))));
};
exports.LanguageSelector = LanguageSelector;
LanguageSelector.propTypes = {
  /** Array of objects like { vendorId: "albelli.nl", href: "https://myaccount.albelli.nl", flag: "flag-nl", text: "NL" } */
  vendorFlagLinks: _propTypes.PropTypes.array,
  /** Current vendor ID (e.g. albelli.nl) */
  currentVendor: _propTypes.PropTypes.string,
  /** Custom/default props can also be added to the root element */
  props: _propTypes.PropTypes.any
};